import type React from "react";

export const PaddleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 512 512"
      {...restProps}
    >
      <title>Paddle Icon</title>
      <g>
        <path
          d="M360.373 267.147c30.571-41.936 41.002-102.098 41.002-152.814C401.375 26.22 336.288 0 256 0S110.625 26.22 110.625 114.333c0 50.873 9.386 111.253 39.879 153.206l67.872 115.728v55.523h-17.79V512H311.95v-73.211H293.5v-55.084zm-59.392-195.83h29.987v29.987h-29.987zm0 59.974h29.987v29.987h-29.987zm0 59.975h29.987v29.987h-29.987zM241.006 71.317h29.987v29.987h-29.987zm0 59.974h29.987v29.987h-29.987zm0 59.975h29.987v29.987h-29.987zm-29.987 29.987h-29.987v-29.987h29.987zm0-59.974h-29.987v-29.987h29.987zm0-59.975h-29.987V71.317h29.987zm66.894 249.311H233.99l-22.31-38.041c13.126 4.205 27.843 6.51 44.32 6.51 16.246 0 30.81-2.381 43.85-6.705z"
          fill={color}
        />
      </g>
    </svg>
  );
};
